import { useNavigate } from "react-router-dom"
import useFormUtility from "../utilities/useFormUtility";
import useHttpUtility from "../utilities/useHttpUtility";
import FormFieldText from "../components/FormFieldText";

export default function PageLogin() {

    const navigate = useNavigate();
    const http = useHttpUtility(true);
    const formUtility = useFormUtility({
        username: "",
        password: ""
    });

    function handleLogin(event) {
        event.preventDefault();
        http.post(
            "/api/Auth/Login",
            formUtility.data,
            () => navigate(`..${window.location.search}`),
            () => {
                formUtility.handleChange([
                    { field: "username", value: "" },
                    { field: "password", value: "" }
                ]);
                formUtility.showNotification(2, "Invalid username or password.");
            }
        );
    }

    return (
        <div className="page-login">
            <div className="middlise">
                <img alt="Urgent Couriers Logo" src="/images/logo.png" className="logo" />

                <form className="login-form">
                    <FormFieldText formUtility={formUtility}
                        field="username"
                        placeholder="Type your username..."
                        classNameControl="login-field"
                    />
                    <FormFieldText
                        formUtility={formUtility}
                        isPassword={true}
                        field="password"
                        placeholder="Type your password..."
                        classNameControl="login-field"
                    />
                    <button className="login-submit" onClick={handleLogin}>Login<span className="login-loading"> <i className="fa fa-spinner fa-pulse fa-fw"></i></span></button>
                </form>

                <div className="links">
                    Haven't got an account?
                    <a rel="noreferrer" href="http://signup.urgent.co.nz" target="_blank">Go here to signup</a>
                </div>
            </div>
        </div>
    );
    
}